import styled from "@emotion/styled";

export const CategoryRailNav = styled.nav<{ stickyTop: number }>`
  position: sticky;
  top: ${({ stickyTop }) => stickyTop}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.space16};
  height: fit-content;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: relative;
    top: 0;
  }
`;

export const CategoryRailList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.space16};
`;

export const CategoryRailLink = styled.a<{ isActive?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};
  text-decoration: ${({ isActive }) => (isActive ? "underline" : "none")};
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }
`;

export const CategoryRailBack = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space4};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.tone.black};

  svg {
    flex-shrink: 0;
  }
`;
